import { render, staticRenderFns } from "./SectionCarousel.vue?vue&type=template&id=eb71f714&scoped=true"
import script from "./SectionCarousel.vue?vue&type=script&lang=js"
export * from "./SectionCarousel.vue?vue&type=script&lang=js"
import style0 from "./SectionCarousel.vue?vue&type=style&index=0&id=eb71f714&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb71f714",
  null
  
)

export default component.exports